import { render, staticRenderFns } from "./teacher-card.vue?vue&type=template&id=b6774132"
import script from "./teacher-card.vue?vue&type=script&lang=js"
export * from "./teacher-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports